import { Link } from 'react-router-dom';
import { es } from '@/i18n/es';
import { routes } from '@/lib/routes';

/**
 * Pie con los enlaces legales.
 *
 * Tiene que estar en todas las pantallas, no sólo en la portada: alojamos obra
 * de terceros, y el canal para reclamarla no puede estar escondido detrás de
 * una pantalla que quizás nadie visita.
 *
 * En mobile lleva un margen extra abajo porque la navegación inferior es fija
 * y si no le tapa la última línea.
 */
export function SiteFooter() {
  return (
    <footer className="mt-12 border-t border-line pt-6 text-sm text-muted">
      <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
        <Link to={routes.terms} className="hover:text-ink hover:underline underline-offset-2">
          {es.legal.terms}
        </Link>
        <Link to={routes.privacy} className="hover:text-ink hover:underline underline-offset-2">
          {es.legal.privacy}
        </Link>
        <Link to={routes.takedown} className="hover:text-ink hover:underline underline-offset-2">
          {es.legal.takedown}
        </Link>
      </nav>
      <p className="mt-3 text-xs">
        {es.landing.footerNote} {es.legal.footerRights}
      </p>
    </footer>
  );
}
